import { render, staticRenderFns } from "./reportcase-manage-handled.vue?vue&type=template&id=7fd25037&scoped=true"
import script from "./reportcase-manage-handled.vue?vue&type=script&lang=ts"
export * from "./reportcase-manage-handled.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd25037",
  null
  
)

export default component.exports